/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * AngularJs component that is used to diplay image on the basis of source and creditType..
 */
angular.module('bulbApp.assetLibraryModule')
  .constant('UnsplashNameThreshold', 10)
  .component('imageAsset', {
    templateUrl: 'ajs/components/image/image-asset.html',
    bindings: {
      imageUrl: '@',
      imageClass: '@',
      imageMetaInfo: '=',
      creditType: '@',
      loadLazy: '<',
      ngStyle: '<',
      ngClass: '<',
      ngClick: '&',
      imageId: '@',
    },
    controller: ['$window', '$scope', 'BulbAssetLibraryUnsplashService', 'BulbPageService', 'UnsplashNameThreshold', 'CONFIG',
      function ImageAsset($window, $scope, BulbAssetLibraryUnsplashService, BulbPageService, UnsplashNameThreshold, CONFIG) {
        const that = this;
        this.id = '';
        this.photographerProfileUrl = '';
        this.photographerName = '';
        this.utmUrl = '';
        this.unsplashUrl = '';
        // Signifies that page is in edit mode or not.
        this.editing = BulbPageService.page.editing;
        if (typeof this.loadLazy === 'undefined') {
          that.loadLazy = true;
        }

        $scope.$watch(() => that.imageMetaInfo, (metaInfo) => {
          if (metaInfo && metaInfo.source === CONFIG.unsplash.label) {
            that.photographerName = that.trimName(metaInfo);
            that.utmUrl = `?utm_source=${CONFIG.unsplash.client.application.name}&utm_medium=referral`;
            that.photographerProfileUrl = `${metaInfo.photographerProfileUrl}${that.utmUrl}`;
            that.unsplashUrl = `https://unsplash.com${that.utmUrl}`;
            that.id = metaInfo.id;
          }
        });

        /**
     * This method opens the passed url in new window eg: unsplash profile of the photographer.
     * @param url the url to be opened in new tab.
     * @param $event event triggered.
     */
        this.redirectTo = function (url, $event) {
          $window.open(url, '_blank');
          $event.stopPropagation();
        };

        /**
     * This method is called every time a image is shown and if the image is an unsplashImage then beacon api is
     * called to update the view count of the pic.
     */
        this.$onInit = function () {
          if (this.imageMetaInfo && this.imageMetaInfo.source === CONFIG.unsplash.label) {
            this.photographerName = that.trimName(this.imageMetaInfo);
            this.photographerProfileUrl = this.imageMetaInfo.photographerProfileUrl;

            BulbAssetLibraryUnsplashService.updateViewCount(this.imageMetaInfo.imageId);
          }
        };

        /**
     * Method to trim name
     */
        this.trimName = function (imageMetaInfo) {
          if (imageMetaInfo.assetDefinitionsKey === 'circularImage'
        && imageMetaInfo.photographerName.length >= UnsplashNameThreshold) {
            return imageMetaInfo.photographerName.substring(0, UnsplashNameThreshold);
          }
          return imageMetaInfo.photographerName;
        };
      }],
  });
